module.exports = "<div class=\"loading text-center\" *ngIf=\"fetchingInProgress\">\n    <div class=\"loading-content\">\n        <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\n        Downloading\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/loading-component/loading-component.component.html
// module id = ../../../../../src/app/common/loading-component/loading-component.component.html
// module chunks = 0